import { callableFactory } from '../callableFactory';

export function prefixTwitch(functionName: string): string {
  return `callable-twitch-${functionName}`;
}

export const callable = callableFactory(prefixTwitch);
